import { routeManifest } from "@/lib/navigation";
import type {
  ServiceQualityCategory,
  ServiceQualityFeature,
} from "./contracts";

function categoryFor(route: (typeof routeManifest)[number]) {
  if (route.id.startsWith("admin"))
    return "Administration" satisfies ServiceQualityCategory;
  if (!route.section || route.section === "Fleet") return "Fleet";
  if (route.section === "Standards and Tastes") return "Standards";
  if (route.section === "Autar Docs") return "Documentation";
  return route.section satisfies ServiceQualityCategory;
}

export const serviceQualityCatalog: ServiceQualityFeature[] = routeManifest.map(
  (route) => ({
    id: route.id,
    label: route.label,
    path: route.path,
    category: categoryFor(route),
    live: route.live,
    telemetry: ["view", "interaction", "api", "failure"],
    objectives: {
      successRatePercent: 99,
      p95LatencyMs: 2_000,
      clientFailureRatePercent: 1,
    },
  }),
);

const specificity = [...serviceQualityCatalog].sort(
  (left, right) => right.path.length - left.path.length,
);

export function featureForPath(pathname: string) {
  const exact = specificity.find((feature) => {
    if (feature.path === "/") return pathname === "/";
    const pattern = feature.path
      .replace(/:[^/]+/g, "[^/]+")
      .replace(/\[[^/]+\]/g, "[^/]+");
    return new RegExp(`^${pattern}/?$`).test(pathname);
  });
  if (exact) return exact;
  const fallbackId = pathname.startsWith("/docs/")
    ? "docs"
    : pathname.startsWith("/repositories/")
      ? "repositories"
      : pathname.startsWith("/tasks/")
        ? "inspection_history"
        : pathname.startsWith("/invitations/")
          ? "access"
          : pathname.startsWith("/verify-email/")
            ? "user_settings"
            : null;
  return fallbackId
    ? serviceQualityCatalog.find((feature) => feature.id === fallbackId)
    : undefined;
}
